// ClinicOS — English translations
export const en: Record<string, string> = {
    // Navigation
    'nav.dashboard': 'Dashboard',
    'nav.patients': 'Patients',
    'nav.appointments': 'Appointments',
    'nav.encounters': 'Encounters',
    'nav.telehealth': 'Telehealth',
    'nav.messages': 'Messages',
    'nav.settings': 'Settings',
    'nav.section.main': 'Main',
    'nav.section.system': 'System',

    // Dashboard
    'dashboard.title': 'Dashboard',
    'dashboard.today_appointments': 'Appointments today',
    'dashboard.active_patients': 'Active patients',
    'dashboard.total_patients': 'Total Patients',
    'dashboard.pending_notes': 'Pending Notes',
    'dashboard.pending_invoices': 'Outstanding invoices',
    'dashboard.welcome': 'Welcome, {name}',
    'dashboard.doctor': 'Doctor',
    'dashboard.greeting.morning': 'Good morning',
    'dashboard.greeting.afternoon': 'Good afternoon',
    'dashboard.greeting.evening': 'Good evening',
    'dashboard.today_agenda': 'Today\'s Agenda',
    'dashboard.view_all': 'View all',
    'dashboard.no_appointments_today': 'No appointments scheduled for today',
    'dashboard.quick_actions': 'Quick Actions',
    'dashboard.action.register_patient': 'Register new patient',
    'dashboard.action.schedule_appointment': 'Schedule new appointment',
    'dashboard.action.view_encounters': 'View recent encounters',
    'dashboard.action.lab_results': 'Laboratory results',

    // Service types
    'service.general-consult': 'General',
    'service.specialist-consult': 'Specialist',
    'service.telehealth-consult': 'Telehealth',
    'service.follow-up': 'Follow-up',
    'service.procedure-minor': 'Procedure',
    'service.lab-review': 'Lab Review',

    // Patients
    'patients.title': 'Patients',
    'patients.search': 'Search patients...',
    'patients.new': 'New Patient',
    'patients.name': 'Name',
    'patients.cedula': 'ID Number',
    'patients.phone': 'Phone',
    'patients.dob': 'Date of Birth',
    'patients.gender': 'Gender',
    'patients.gender.male': 'Male',
    'patients.gender.female': 'Female',
    'patients.gender.other': 'Other',
    'patients.insurance': 'Insurance',
    'patients.view': 'View Patient',
    'patients.no_results': 'No patients found',

    // Appointments
    'appointments.title': 'Appointments',
    'appointments.new': 'New Appointment',
    'appointments.date': 'Date',
    'appointments.time': 'Time',
    'appointments.doctor': 'Doctor',
    'appointments.patient': 'Patient',
    'appointments.type': 'Type',
    'appointments.type.in_person': 'In Person',
    'appointments.type.telehealth': 'Telehealth',
    'appointments.status': 'Status',
    'appointments.status.booked': 'Booked',
    'appointments.status.confirmed': 'Confirmed',
    'appointments.status.arrived': 'Arrived',
    'appointments.status.in_progress': 'In Progress',
    'appointments.status.completed': 'Completed',
    'appointments.status.cancelled': 'Cancelled',
    'appointments.status.no_show': 'No Show',
    'appointments.reason': 'Chief Complaint',

    // SOAP Notes
    'soap.title': 'SOAP Note',
    'soap.subjective': 'Subjective',
    'soap.objective': 'Objective',
    'soap.assessment': 'Assessment',
    'soap.plan': 'Plan',
    'soap.diagnoses': 'Diagnoses',
    'soap.medications': 'Medications',
    'soap.vitals': 'Vitals',
    'soap.sign': 'Sign Note',
    'soap.save_draft': 'Save Draft',
    'soap.signed': 'Signed',
    'soap.ai_draft': 'AI Draft',
    'soap.voice_scribe': 'Voice Scribe',

    // Billing
    'billing.title': 'Billing',
    'billing.invoices': 'Invoices',
    'billing.total': 'Total',
    'billing.status.draft': 'Draft',
    'billing.status.sent': 'Sent',
    'billing.status.paid': 'Paid',
    'billing.status.overdue': 'Overdue',

    // Common
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.delete': 'Delete',
    'common.edit': 'Edit',
    'common.close': 'Close',
    'common.loading': 'Loading...',
    'common.confirm': 'Confirm',
    'common.back': 'Back',
    'common.search': 'Search',
    'common.filter': 'Filter',
    'common.actions': 'Actions',
    'common.yes': 'Yes',
    'common.no': 'No',
    'common.coming_soon': '🚧 Coming Soon',

    // Auth
    'auth.login': 'Sign In',
    'auth.logout': 'Sign Out',
    'auth.welcome': 'Welcome',
};
